import { isGuest } from "$ACTIONS/helper";

// Promotion item status Enum
export const promotionStatusMapping = [
    {
        type: "goApply",
        tagText: "สมัครตอนนี้",
        tagCN: "立即申请",
        isButtonStyle: false,
        isDisabled: false,
        statusList: [
            { statusName: "APPLY_FORM", isNeedLogin: false },
            { statusName: "NO_FORM", isNeedLogin: false },
            { statusName: "FUND_IN", isNeedLogin: false },
            { statusName: "DEPOSIT_PAGE_ONLY", isNeedLogin: false },
            { statusName: "REQUIRED_LOGIN", isNeedLogin: false },
            { statusName: "READY_TO_ENROLL", isNeedLogin: true },
            // {statusName: "FUND_IN", isNeedLogin:true}, //測試用
        ],
    },
    {
        type: "reviewing",
        tagText: "รอการตรวจสอบ",
        tagCN: "审核中",
        isButtonStyle: true,
        isDisabled: true,
        statusList: [{ statusName: "PENDING_RESULT", isNeedLogin: true }],
    },
    {
        type: "readyToStart",
        tagText: "มีสิทธิ์เข้าร่วม",
        btnText: "ขอรับตอนนี้",
        tagCN: "符合资格",
        btnCN: "开始优惠",
        isButtonStyle: true,
        statusList: [{ statusName: "START_TO_CLAIM", isNeedLogin: true }],
    },
    {
        type: "applied",
        tagText: "ขอรับแล้ว",
        tagCN: "已申请",
        isButtonStyle: true,
        isDisabled: true,
        statusList: [{ statusName: "ALREADY_APPLIED", isNeedLogin: true }],
    },
    {
        type: "claimed",
        tagText: "รับโบนัสแล้ว",
        tagCN: "已领取",
        isButtonStyle: true,
        isDisabled: true,
        statusList: [{ statusName: "ALREADY_CLAIMED", isNeedLogin: true }],
    },
    {
        type: "noAction",
        tagText: "ดูรายละเอียด",
        tagCN: "查看詳情",
        isButtonStyle: false,
        statusList: [{ statusName: "NO_ACTION", isNeedLogin: false }],
    },
    // tag不顯示此狀態，只用於TnC CTA btn
    {
        type: "notInPromotionPeriod",
        btnText: "ขอรับได้ภายในระยะเวลาที่กำหนด",
        btnCN: "仅限指定时段申请",
        isButtonStyle: false,
        isDisabled: true,
        statusList: [
            { statusName: "NOT_DURING_PERIOD", isNeedLogin: false }, //自創 statusName value
        ],
    },
];

/**
 * 取得Promotion對應之Status item
 * @param {*} promoItem  selectedPromoItem
 * @returns {object } statusItem configuration
 */
export const getPromotionStatus = (promoItem) => {
    const isLogin = !isGuest();
    let status;
    const { actionType, bonusData, promoType } = promoItem || {};

    //只有在TnC畫面才有NOT_DURING_PERIOD scenario, promoType只有promotion detail會回傳，所以需確認其有值
    const isNotDuringPromotionPeriod =
        promoType &&
        promoType !== "Bonus" &&
        (promoItem.isNotStart ||
            promoItem.isExpired ||
            !promoItem.isInApplicationDuration);

    if (isNotDuringPromotionPeriod) {
        status = "NOT_DURING_PERIOD"; //自創statusName value
    } else {
        if (isLogin) {
            switch (actionType) {
                case "APPLY_FORM":
                case "NO_FORM": {
                    const { entryPeriod } = promoItem?.campaignData || {};
                    if (entryPeriod) {
                        status = entryPeriod?.displayStatus;
                    } else {
                        status = "NO_ACTION";
                    }
                    break;
                }
                case "FUND_IN":
                case "DEPOSIT_PAGE_ONLY":
                    if (bonusData) {
                        const { isApplied } = bonusData;
                        if (isApplied) {
                            status = "ALREADY_APPLIED";
                        } else {
                            status = actionType;
                        }
                    } else {
                        status = "NO_ACTION";
                    }
                    break;
                default:
                    status = actionType;
                    break;
            }
        } else {
            status = actionType;
        }
    }

    const statusItem = promotionStatusMapping.find((item) => {
        return item.statusList.some((status_item) => {
            // 僅有未登入狀態時需要確認 isNeedLogin
            return (
                (!isLogin ? status_item.isNeedLogin === isLogin : true) &&
                status_item.statusName === status
            );
        });
    });
    return statusItem;
};
